module.exports = __webpack_public_path__ + "img/add.46626092.svg";